import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useParams } from "react-router-dom";

import { isSupportedLocale } from "./config";

/**
 * LanguageRoute — `/:lang/...` の lang セグメントを受けて i18next を切替える。
 *
 * 不正 / 未対応 lang は同じパスの :lang を i18n の現在言語に差替えてリダイレクト。
 * 正常時は i18n.language を URL に追従させ、子ルートを Outlet で描画する。
 */
export function LanguageRoute() {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();

  const valid = isSupportedLocale(lang);

  useEffect(() => {
    if (valid && lang && i18n.language !== lang) {
      void i18n.changeLanguage(lang);
    }
  }, [valid, lang, i18n]);

  if (!valid) {
    const rest = window.location.pathname.split("/").slice(2).join("/");
    const search = window.location.search;
    const target = `/${i18n.resolvedLanguage ?? i18n.language}${rest ? `/${rest}` : ""}${search}`;
    return <Navigate to={target} replace />;
  }

  return <Outlet />;
}
